<template>
  <div
    @click="$emit('filter-by-sale')"
    :class="isForSale ? 'bg-blue-50 text-blue-600' : ''"
    class="relative text-sm cursor-pointer border border-gray-200 bg-white transition-all w-fit rounded-lg duration-300 px-5 py-1 flex items-center justify-between"
  >
    <div class="flex items-center space-x-2 transition-all duration-300">
      <Icon name="ph:tag" size="18" />
      <span>{{ $t("filter.available_for_sale") }}</span>
    </div>
    <button
      v-if="isForSale"
      class="cursor-pointer size-4 min-w-4 absolute -top-1 z-10 bg-white rounded-full border border-gray-200 shadow-2xl -right-1 flex items-center justify-center"
      title="Remove filter"
      type="button"
    >
      <Icon name="ph:x" size="10" />
    </button>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(["filter-by-sale"]);

defineProps<{
  isForSale: boolean;
}>();
</script>
